import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
  const isLocal = window.location.host.includes('localhost');
  let environmentFileListener = setInterval(()=>{
    if(window && ((window as any).UIenvironments || isLocal)){
      clearInterval(environmentFileListener);
      !isLocal && enableProdMode();
      platformBrowserDynamic().bootstrapModule(AppModule)
        .catch(err => console.error(err));
    }
  },10)
